// removed by extract-text-webpack-plugin
module.exports = {"arrowContainer":"_1bpeJ","prev":"_bWwUM","next":"_oMLvg","arrow":"_3LM2g"};


//////////////////
// WEBPACK FOOTER
// ./app/components/ChannelBar/components/Arrows/Arrows.scss
// module id = 1026
// module chunks = 2